import { ContributorStoreType } from "store/type";

export const initGlobalState: ContributorStoreType = {
	contributors: [],
	addMiniContributorModal: false,
	getContributorLoading: false,
	saveContributorLoading: false,
	getContributorArtistLoading: false,
	contributorArtists: [],
	saveContributorArtistLoading: false,
	artistRoyaltyRevenueDetail: {},
	artistRoyaltyRevenueDetailLoading: false,
	allArtistRoyaltyRevenue: [],
	updateArtistRoyaltyRevenueLoading: false,
	artistRoyaltyRevenueContributions: [],
  artistRoyaltyRevenueContributionsLoading: false,
};
